export type ClickShape = { clientX: number; clientY: number };

export type ClickSignalFunctionReferenceMap = {
    name: keyof IStateEventMap;
    listener: (ev: IStateEventMap[keyof IStateEventMap]) => void;
};

interface IStateEventMap {
    click: CustomEvent<ClickShape>;
}

interface IStateEventTarget extends EventTarget {
    addEventListener(
        type: string,
        callback: EventListenerOrEventListenerObject | null,
        options?: EventListenerOptions | boolean,
    ): void;
    addEventListener<K extends keyof IStateEventMap>(
        type: K,
        listener: (ev: IStateEventMap[K]) => void,
        options?: boolean | AddEventListenerOptions,
    ): void;
    removeEventListener(
        type: string,
        callback: EventListenerOrEventListenerObject | null,
        options?: EventListenerOptions | boolean,
    ): void;
    removeEventListener<K extends keyof IStateEventMap>(
        type: K,
        listener: (ev: IStateEventMap[K]) => void,
        options?: boolean | AddEventListenerOptions,
    ): void;
}

const typedEventTarget = EventTarget as {
    new (): IStateEventTarget;
    prototype: IStateEventTarget;
};

export default class ClickSignal extends typedEventTarget {
    public static inst = new ClickSignal();
    static sendClick(detail: ClickShape) {
        const custom = new CustomEvent<ClickShape>("click", {
            detail,
        });
        ClickSignal.inst.dispatchEvent(custom);
    }
    static receiveClick(
        listener: (ev: IStateEventMap[keyof IStateEventMap]) => void,
    ): ClickSignalFunctionReferenceMap {
        ClickSignal.inst.addEventListener("click", listener);
        return { name: "click", listener }; // to destroy later
    }
}
